import { formatarPreco } from '@peniel/shared'

import { cn } from '@/shared/lib/cn.js'

interface PropsPrecoProduto {
  centavos: number
  /** Riscado: o card VENDIDA do protótipo mostra o preço com line-through. */
  riscado?: boolean
  className?: string
}

/**
 * Preço formatado em pt-BR.
 *
 * `<data value>` deixa o valor numérico legível por máquina (útil para o
 * JSON-LD e para extensões de comparação de preço), enquanto o texto visível
 * fica formatado para humanos.
 */
export function PrecoProduto({ centavos, riscado = false, className }: PropsPrecoProduto) {
  const formatado = formatarPreco(centavos)

  if (riscado) {
    return (
      <data value={(centavos / 100).toFixed(2)} className={cn('block', className)}>
        <span className="sr-only">Preço anterior: </span>
        <s>{formatado}</s>
      </data>
    )
  }

  return (
    <data value={(centavos / 100).toFixed(2)} className={cn('block', className)}>
      {formatado}
    </data>
  )
}
